module.exports = __webpack_public_path__ + "img/form-cta-bg-mobile.f89074fc.webp";